import { useState, useEffect } from "react";
import SplashScreen from "@/components/SplashScreen";

import { useAuthContext } from "@/hooks/use-auth-context";
import { useRouter, useSearchParams } from "@/routes/hooks";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function GuestGuard({ children }: Props) {
  const router = useRouter();

  const searchParams = useSearchParams();

  const { loading, authenticated } = useAuthContext();

  const [isChecking, setIsChecking] = useState<boolean>(true);

  const returnTo = searchParams.get("returnTo") || "/new";

  useEffect(() => {
    if (loading) {
      return;
    }

    if (authenticated) {
      router.replace(returnTo);
      return;
    }

    setIsChecking(false);
  }, [authenticated, loading, router, returnTo]);

  if (isChecking) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
